import * as React from 'react';
import { Switch, withRouter } from 'react-router-dom';

import AppNavBar from 'src/components/layout/AppNavBar';
import SecondWindowNavBar from 'src/components/layout/SecondWindowNavBar';

import { RouteComponentProps } from 'react-router';

import routes from 'src/routes';

import './App.scss';
import { UserRoles } from 'src/models/UserRole';
import { Dialog } from '@blueprintjs/core';
import { IRootState } from 'src/reducers';
import selectors from 'src/selectors';
import actions from 'src/actions';
import { push } from 'connected-react-router';
import { compose } from 'redux';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';

import ApiProvider from 'src/providers/ApiProvider';
import DialogProvider from 'src/providers/DialogProvider';
import AppContextProvider from 'src/providers/AppContextProvider';
import UserDetails from 'src/models/UserDetails';
// import PersonnelNavBar from '../personnel/components/PersonnelNavBar';
// import AccountsPayableNavBar from '../personnel/components/AccountsPayableNavBar';

interface IAppStateProps {
    isLoggedIn: boolean;
    isAdmin: boolean;
    isSecondWindow: boolean;
    secondWindowOpen: boolean;
    user: UserDetails;
}

export interface IAppDispatchProps {
    setLoadingState: (state: boolean) => void;
    changeRole: (roles: UserRoles) => void;
    navigate: (path: string) => void;
}

interface IAppState {
    roleSwitcherShowing: boolean;
    searchEnterWillSelect: boolean;
    currentSearchIndex: number;
}

type IAppProps = RouteComponentProps & IAppStateProps & IAppDispatchProps;

class App extends React.Component<IAppProps, IAppState> {
    constructor(props: IAppProps) {
        super(props);

        this.state = {
            roleSwitcherShowing: false,
            searchEnterWillSelect: false,
            currentSearchIndex: 0,
        };
    }

    static getDerivedStateFromProps(props: IAppProps, state: IAppState) {
        if (props.isLoggedIn) {
            document.body.classList.remove('login');
        } else {
            document.body.classList.add('login');
        }
        return state;
    }

    // UNSAFE_componentWillReceiveProps(nextProps: IAppProps) {
    //   this.updateBodyClass(nextProps);
    //   return state;
    // }

    handleKeyPress = (event: KeyboardEvent) => {
        if (this.props.isLoggedIn) {
            if (event.key === 'F4' && this.props.isAdmin) {
                this.setState({ roleSwitcherShowing: true });
            }
        }
    };

    hideDialog = () => {
        this.setState({ roleSwitcherShowing: false });
    };

    setEmployee = () => {
        // this.props.changeRole(UserRoles.Employee);
        this.setState({ roleSwitcherShowing: false });
    };

    setContractor = () => {
        // this.props.changeRole(UserRoles.Contractor);
        this.setState({ roleSwitcherShowing: false });
    };

    public componentDidMount() {
        if (this.props.isLoggedIn) {
            document.body.classList.remove('login');
        } else {
            document.body.classList.add('login');
        }
        window.addEventListener('keydown', this.handleKeyPress, false);
    }

    showNavBar = () => {
        if (!this.props.isLoggedIn) {
            return undefined;
        }

        // if (window.location.pathname.includes('personnel')) {
        //     return <PersonnelNavBar/>;
        // } else if (window.location.pathname.includes('accounts-payable')) {
        //     return <AccountsPayableNavBar/>;
        // } else {
        //     return !this.props.isSecondWindow ? <AppNavBar {...this.props} /> : <SecondWindowNavBar {...this.props} />;
        // }

        return !this.props.isSecondWindow ? <AppNavBar {...this.props} /> : <SecondWindowNavBar {...this.props} />;
    };

    getClassName = () => {
        const pathname = window.location.pathname;
        if (this.props.isLoggedIn && !!pathname) {
            if (
                pathname.includes('personnel') ||
                pathname.includes('accounts-payable') ||
                pathname.includes('client-project') ||
                pathname.includes('project-billing') ||
                pathname.includes('gis')
            ) {
                return 'with-other-nav';
            } else if (this.props.isSecondWindow) {
                return 'with-second-window-nav';
            } else {
                return 'with-nav';
            }
        } else {
            return '';
        }
    };

    render() {
        const content = (
            <AppContextProvider>
                <ApiProvider>
                    <DialogProvider>
                        {this.showNavBar()}
                        <main className={this.getClassName()}>
                            <Switch>{routes(this.props.isLoggedIn, this.props.isAdmin, this.props.user)}</Switch>
                        </main>

                        <Dialog title="Change Role" isOpen={this.state.roleSwitcherShowing} onClose={this.hideDialog}>
                            <div className="forgotPasswordDialog">
                                <button type="button" className="bp3-button pt-intent-primary" onClick={this.setEmployee}>
                                    Set Employee
                                </button>
                                <button type="button" className="bp3-button pt-intent-primary" onClick={this.setContractor}>
                                    Set Contractor
                                </button>
                            </div>
                        </Dialog>

                        <div id="form-debug-portal" />
                        <div id="context-menu-portal" />
                    </DialogProvider>
                </ApiProvider>
            </AppContextProvider>
        );

        return content;
    }
}

const mapStateToProps = (state: IRootState) => ({
    isLoggedIn: selectors.auth.isLoggedIn(state),
    isAdmin: selectors.auth.user(state).isAdmin,
    isSecondWindow: selectors.layout.isSecondWindow(state),
    secondWindowOpen: selectors.layout.secondWindowOpen(state),
    user: selectors.auth.user(state),
});

const mapDispatchToProps: IAppDispatchProps = {
    setLoadingState: (loadingState: boolean) => actions.layout.setInitalLoadState(loadingState),
    changeRole: (role: UserRoles) => actions.auth.changeRole(role),
    navigate: (path: string) => push(path),
};

export default compose(hot(module), withRouter, connect(mapStateToProps, mapDispatchToProps))(App);



// WEBPACK FOOTER //
// ./src/components/app/App.tsx